import { useOnboardingWizard } from '@epi-shared/hooks/useOnboardingWizard';

const useOnboarding = () => {
  const { isOnBoardingActive, isSuccess, flags } = useOnboardingWizard();

  const benefitGroupNotExists =
    isOnBoardingActive && isSuccess && !flags?.isBenefitsSet;

  return { benefitGroupNotExists };
};

export { useOnboarding };
